export default __webpack_public_path__ + "static/media/OneDrive.d9b07ca5.svg";